<template>
<div>
    <div class="pc">
        <div class="con-icon"><img src="@/assets/newImages/common/common-icon.png" alt=""></div>
        <div class="content">
            <!-- 标题 -->
            <div class="con-head">
                <p>重磅嘉宾</p>
                <div class="search">
                    <input type="text" placeholder="请输入您感兴趣的嘉宾" placeholder-style="color:#AAAAAA" v-model="keyWords" @keyup.enter="doSearch()">
                    <div @click="doSearch()">
                        <img src="@/assets/newImages/hotNews/search.png" alt="">
                    </div>
                </div>
            </div>
            <!-- 内容 -->
            <div class="con-guest" :style="{height:pageHeight}" v-if="guestsList.length>0">
                <div class="guest-one">
                    <div class="one" v-for="(guest,index) in guestsList" :key="index" @click="isShow(guest)" >
                        <div class="top">
                            <img :src="guest.realPath" alt="">
                        </div>
                        <div class="bottom">
                            <p class="name">{{guest.name}}</p>
                            <p class="introduce">{{guest.duty}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="con-guest" style="display:flex;background:#fff;" :style="{height:pageHeight}" v-if="guestsList.length==0&&keyWords">
                <p style="color:gray;font-size:24px;margin:auto;">暂无您要搜索的内容</p>
            </div>
            <div class="con-guest" style="display:none;background:#fff;" :style="{height:pageHeight}">
                <p style="color:gray;font-size:24px;margin:auto;">敬请期待</p>
            </div>
            
        </div>
        <!-- 弹窗 -->
        <div class="mask" v-if="showModel" @click="closeModel()" @touchmove.prevent @mousewheel.prevent></div>
        <div class="pop" v-if="showModel">
            <div class="p" @click="closeModel()"><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
            <div class="intro">
                <div class="pic">
                    <img :src="guestPop.realPath" alt="">
                </div>
                <div class="explain">
                    <div class="name">{{guestPop.name}}</div>
                    <div class="post">{{guestPop.duty}}</div>
                    <!-- <div class="text">{{guestPop.intro}}</div> -->
                </div>
            </div>
            <div class="agenda">
                <div class="title"><p>演讲议程</p></div>
                <div class="agenda-item">
                    <div class="item" v-for="(item,index) in guestPop.seminarList" :key="index">
                        <div class="top">
                            <div class="t-img"><img src="@/assets/newImages/common/line.png" alt=""></div>
                            <div class="t-text">{{item.name}}</div>
                        </div>
                        <div class="place">
                            <div class="p-time">
                                <div class="time-img"><img src="@/assets/newImages/guest/pop-icon1.png" alt=""></div>
                                <p>{{item.startTime_h_m}} - {{item.endTime_h_m}}</p>
                            </div>
                            <div class="p-time p-address">
                                <div class="address-img" v-if="item.address!=null&&item.address!=''"><img src="@/assets/newImages/guest/pop-icon2.png" alt=""></div>
                                <p>{{item.address}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    <div class="wap">
        <div class="page-img"><img src="@/assets/newImages/common/navWap/page-img.png" alt=""></div>
        <div class="content" :class="{'wap-cover':showModel}" :style="{top:contentTop,height:contentHeight}">
            <!-- 标题 -->
            <div class="con-header"><p>重磅嘉宾</p></div>
            <div class="con-main">
                <div class="input-div">
                    <input type="text" name="" id="" v-model="keyWords" placeholder="请输入关键字搜索">
                    <div class="search" @click="doSearch()">
                        <img src="@/assets/newImages/hotNews/search.png" alt="search">
                    </div>
                </div>
                <div class="guest-one" v-if="guestsList.length>0">
                    <div class="one" v-for="(guest,index) in guestsList" :key="index" @click="isShow(guest)" >
                        <div class="top">
                            <img :src="guest.realPath" alt="">
                        </div>
                        <div class="bottom">
                            <p class="name">{{guest.name}}</p>
                            <p class="introduce">{{guest.duty}}</p>
                        </div>
                    </div>
                </div>
                <div class="guest-one" style="display:flex;background:#fff;height:50vw;" v-if="guestsList.length==0&&keyWords">
                    <p style="color:gray;font-size:16px;margin:auto;">暂无您要搜索的内容</p>
                </div>
                <div class="guest-one" style="display:none;background:#fff;height:50vw;">
                    <p style="color:gray;font-size:24px;margin:auto;">敬请期待</p>
                </div>
            </div>
        </div>
    </div>
    <div class="maskWap" v-if="!isPc&&showModel" @click="closeModel()" @touchmove.prevent @mousewheel.prevent></div>
    <div class="popWap" v-if="!isPc&&showModel">
        <div class="top-div" @touchmove.prevent @mousewheel.prevent></div>
        <div class="p" @click="closeModel()" @touchmove.prevent @mousewheel.prevent><img src="@/assets/newImages/home/cover-close.png" alt=""></div>
        <div class="border" @touchmove.prevent @mousewheel.prevent>
            <div class="intro">
                <div class="pic">
                    <img :src="guestPop.realPath" alt="">
                </div>
                <div class="explain">
                    <div class="name">{{guestPop.name}}</div>
                    <div class="post">{{guestPop.duty}}</div>
                </div>
            </div>
            <div class="text">{{guestPop.intro}}</div>
        </div>
        <div class="agenda">
            <div class="title-div" @touchmove.prevent @mousewheel.prevent>
                <div class="title"><p>演讲议程</p></div>
            </div>
            <div class="agenda-item">
                <div class="item" v-for="(item,index) in guestPop.seminarList" :key="index">
                    <div class="top">
                        <div class="t-img"><img src="@/assets/newImages/common/line.png" alt=""></div>
                        <div class="t-text">{{item.name}}</div>
                    </div>
                    <div class="place">
                        <div class="p-time">
                            <div class="time-img"><img src="@/assets/newImages/guest/pop-icon1.png" alt=""></div>
                            <p>{{item.startTime_h_m}} - {{item.endTime_h_m}}</p>
                        </div>
                        <div class="p-time p-address">
                            <div class="address-img" v-if="item.address!=null&&item.address!=''"><img src="@/assets/newImages/guest/pop-icon2.png" alt=""></div>
                            <p>{{item.address}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-div" @touchmove.prevent @mousewheel.prevent></div>
    </div>
</div>
    
</template>
<script>
import api from '../api';
import { constructData, timestampToTime } from '@/utils/tool';
export default {
    data(){
        return{
            pageHeight:'',
            height:document.documentElement.clientHeight,
            isPc: document.documentElement.clientWidth > 750 ? true : false,
            width:document.documentElement.clientWidth,
            contentTop:'',
            contentHeight:'',
            scrollIndex:'',
            guestsList:[],
            guestsListOri:[],
            showModel:false,
            guestPop:{
                realPath: '',
                name: '',
                intro: '',
                duty: '',
                seminarList: []
            },
            keyWords: '',
        }
    },
    created(){
        this.pageHeight = this.height-199/1920*this.width-48/1920*this.width+"px"
        this.getGuestList();
    },
    methods:{
        isShow(guest){

            // 埋码
            this.$maima.guest_page_information_click(guest.name, guest.duty, guest.seminarNames);
            //判断可滑动区域超出隐藏
            this.scrollIndex=$(".content").offset().top-0.1*this.width
            this.contentTop=0.1*this.width-$(".content").offset().top+'px'
            this.contentHeight = $(".content").offset().top-0.1*this.width+this.height+'px'
            this.showModel=true
            let temp = guest;
            if(temp.seminarList.length>0){
                temp.seminarList.map(item=>{
                    item.startTimeStr = timestampToTime(item.startTime);
                    item.startTime_h_m = item.startTimeStr.substr(11, 5);
                    item.endTimeStr = timestampToTime(item.endTime);
                    item.endTime_h_m = item.endTimeStr.substr(11, 5);
                });
            }
            this.guestPop=temp
        },
        // 嘉宾列表
        getGuestList(){
            if(!this.$store.state.showControl.showNavGuest){
                return;
            }

            let that = this;
            api.getGuestList()
            .then(res=>{
                if(res){
                    that.guestsList = res;
                    that.guestsListOri = res;
                }
            })
            .catch(err=>{
            });
        },
        closeModel(){
            this.showModel=false;
            this.contentTop='';
            this.contentHeight='';
            this.guestPop={
                realPath: '',
                name: '',
                intro: '',
                duty: '',
                seminarList: []
            };
        },
        doSearch(){
            if(this.keyWords){
                let data = this.guestsListOri;
                let temp = [];
                data.map(item=>{
                    if(item.seoWords.indexOf(this.keyWords) != -1){
                        temp.push(item);
                    }
                })
                this.guestsList = temp;
            }else{
                this.guestsList = this.guestsListOri;
            }
        },
    }
}
</script>
<style scoped lang="scss">
*{
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
.pc{
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: url('../assets/newImages/common/common-bg.png')no-repeat center center/cover;
    .con-icon{
        position: absolute;
        right: 0;
        bottom: 0;
        width: pxToVw(480);
        height: pxToVw(403);
        img{
            width: pxToVw(480);
            height: pxToVw(403);
        }
    }
    .content{
        width: pxToVw(1600);
        margin: pxToVw(0) pxToVw(0) 0 pxToVw(233);
        padding-top: pxToVw(49);
        position: relative;
        z-index: 2;
        .con-head{
            width: 100%;
            height: pxToVw(115);
            text-align: left;
            display: flex;
            justify-content: space-between;
            p{  
                width: pxToVw(351);
                height: pxToVw(115);
                padding: pxToVw(36) 0 0 pxToVw(92);
                font-size: pxToVw(43);
                font-family: "FZLT-blackBold";
                color: #FFF;
                line-height: pxToVw(52);
                background: url("../assets/newImages/common/common-title-bg.png")no-repeat center center/cover;
            }
            .search{
                margin: pxToVw(84) pxToVw(18) pxToVw(0) pxToVw(0);
                width: pxToVw(316);
                height: pxToVw(39);
                background: #FFFFFF;
                box-shadow: 0px 0px pxToVw(24) 0px rgba(231,231,231,0.5);
                border-radius: pxToVw(20);
                display: flex;
                align-items: center;
                padding:pxToVw(0) pxToVw(0) pxToVw(0) pxToVw(33);
                // margin-top: pxToVw(-60);
                input{
                    width: pxToVw(225);
                    border: none;
                    outline: none;
                    font-size: pxToVw(19);
                    font-weight: normal;
                    color: #0a0a0a;
                    line-height: pxToVw(23);
                    &::placeholder{
                        color: #AAAAAA;
                    }
                }
                    input::-webkit-search-cancel-button{
                        display: none;
                    }
                    input[type=text]::-ms-clear{
                        display: none;
                    }
                div{
                    width: pxToVw(21);
                    height: pxToVw(21);
                    margin-left: pxToVw(11);
                    cursor: pointer;
                    z-index: 2;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
        .con-guest{
            margin: pxToVw(20) pxToVw(0) pxToVw(0) pxToVw(63);
            padding-right: pxToVw(15);
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
            /*滚动条样式*/
            &::-webkit-scrollbar{
                width: pxToVw(3);
                background: none; 
            }
            &::-webkit-scrollbar-track{
                background: none;
            }
            &::-webkit-scrollbar-thumb{
                background: #DDDDDD;
            }
            .guest-one{
                height: auto;
                flex-wrap: wrap;
                display: flex;
                background: RGBA(253, 253, 253, .9);
                box-shadow: 0px 0px pxToVw(27) 0px rgba(231,231,231,0.5);
                padding: pxToVw(16) pxToVw(27) pxToVw(43);
                border-radius: pxToVw(2);
                .one{
                    width: pxToVw(267);
                    height: pxToVw(427);
                    border-radius: 0px 0px pxToVw(3) pxToVw(3);
                    background: #fff;
                    box-shadow: 0px 0px pxToVw(11) 0px rgba(235,235,235,0.5);
                    margin: pxToVw(27) pxToVw(32) 0 pxToVw(0);
                    cursor: pointer;
                    &:nth-child(5n){
                        margin-right: 0;
                    }
                    .top{
                        width: pxToVw(267);
                        height: pxToVw(267);
                        // padding: pxToVw(36) 0 0 pxToVw(43);
                        overflow: hidden;
                        background: url('../assets/newImages/guest/bg.png')no-repeat center center/cover;
                        position: relative;
                        img{
                            // width: pxToVw(216);
                            height: pxToVw(231);
                            position: absolute;
                            top: pxToVw(40);
                            left: 50%;
                            transform: translateX(-50%);
                        }
                        
                    }
                    .bottom{
                        height: pxToVw(160);
                        padding: pxToVw(20);
                        .name{
                            width: pxToVw(78);
                            font-size: pxToVw(24);
                            font-family: "FZLT-blackLittle";
                            font-weight: normal;
                            color: #333333;
                            line-height: pxToVw(28);
                            text-align: justify;
                            text-align-last: justify;
                            word-break: break-all;
                            text-justify: distribute;
                        }
                        .introduce{
                            font-size: pxToVw(16);
                            font-weight: normal;
                            color: #999999;
                            line-height: pxToVw(29);
                            margin-top: pxToVw(12);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
    }
    .mask{
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background: rgba(0,0,0,0.5);
            z-index: 1000;
            cursor: pointer;
        }
        .pop{
            background: #fff;
            width: pxToVw(883);
            // height: pxToVw(653);
            height: auto;
            position: fixed;
            z-index:10001;
            left:50% ;
            transform: translate(-50%,-50%);
            top: 50%;
            padding: pxToVw(0) pxToVw(0) pxToVw(57);
            .p{
                width: pxToVw(19);
                height: pxToVw(19);
                position: absolute;
                right: pxToVw(17);
                top: pxToVw(17);
                cursor: pointer;
                img{
                    width: 100%;
                }
            }
            .intro{
                border-bottom: 1px solid #EEEEEE;
                padding:pxToVw(43) pxToVw(40) pxToVw(29) ;
                display: flex;
                align-items: center;
                .pic{
                    width: pxToVw(289);
                    height: pxToVw(288);
                    position: relative;
                    overflow: hidden;
                    background: url('../assets/newImages/guest/pop-bg.png') no-repeat center center/cover;
                    img{
                        // width: pxToVw(212);
                        height: pxToVw(225);
                        position: absolute;
                        top: pxToVw(52);
                        // left: pxToVw(39);
                        left: 50%;
                        transform: translateX(-50%);
                    }
                }
                .explain{
                    width: pxToVw(439);
                    margin-left:pxToVw(24);
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    .name{
                        font-size: pxToVw(27);
                        font-weight: normal;
                        color: #333333;
                        font-family: "FZLT-blackLittle";
                        line-height: pxToVw(32);
                        margin-top: pxToVw(33);
                        width: pxToVw(99);
                        text-align: justify;
                        text-align-last: justify;
                        word-break: break-all;
                        text-justify: distribute;
                    }
                    .post{
                        font-size: pxToVw(19);
                        font-weight: normal;
                        color: #666;
                        line-height: pxToVw(27);
                        margin-top: pxToVw(13);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    .text{
                        font-size: pxToVw(19);
                        font-weight: normal;
                        color: #999;
                        line-height: pxToVw(29);
                        margin-top: pxToVw(33);
                        height: pxToVw(144);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                    }
                }
            }
            .agenda{
                margin-top: pxToVw(32);
                .title{
                    width: pxToVw(175);
                    height: pxToVw(49);
                    background: url('../assets/newImages/guest/pop-title.png')no-repeat center center/cover;
                    padding: pxToVw(17) pxToVw(0) pxToVw(0) pxToVw(51);
                    p{
                        font-size: pxToVw(21);
                        font-weight: normal;
                        color: #FFFFFF;
                        line-height: pxToVw(25);
                    }
                }
                .agenda-item{
                    width: 100%;
                    height: auto;
                    max-height: 30vh;
                    overflow-y: scroll;
                    cursor: pointer;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    &::-webkit-scrollbar{
                        width: 0px;
                    }
                }
                .item{
                    margin: pxToVw(20) 0 0 pxToVw(32);
                    .top{
                        display: flex;
                        align-items: center;
                        .t-img{
                            width: pxToVw(10);
                            height: pxToVw(10);
                            img{
                                width: 100%;
                                vertical-align: top;
                            }
                        }
                        .t-text{
                            width: pxToVw(731);
                            font-size: pxToVw(19);
                            font-weight: normal;
                            color: #333333;
                            line-height: pxToVw(23);
                            margin-left: pxToVw(20);
                            overflow:hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .place{
                        display: flex;
                        align-items: center;
                        margin: pxToVw(13) 0 0 pxToVw(28);
                        .p-time{
                            width: pxToVw(180);
                            display: flex;
                            align-items: center;
                            margin-right: pxToVw(10);
                            .time-img{
                                width: pxToVw(15);
                                height: pxToVw(15);
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                            .address-img{
                                width: pxToVw(15);
                                height: pxToVw(19);
                                img{
                                    width: 100%;
                                    vertical-align: top;
                                }
                            }
                            p{
                                width:pxToVw(150);
                                font-size: pxToVw(16);
                                font-weight: normal;
                                color: #999999;
                                line-height: pxToVw(19);
                                margin-left: pxToVw(10);

                            }
                        }
                        .p-address{
                            width: pxToVw(360);
                            p{
                                width:pxToVw(330);
                            }
                        }
                    }
                }
            }
        }
}
.wap{
    display: none;
}
@media screen and (max-width:767px) {
    .pc{
        display: none;
    }
    .wap{
        display: block;
        position: relative;
        z-index: 2;
        width: 100%;
        height: auto;
        min-height: 100vh;
        padding: 10vw 0 13.3vw;
        background: url('../assets/newImages/exhibitionGuide/wap-bg.png')no-repeat center center/cover;
        .page-img{
            position: absolute;
            bottom: 0;
            z-index: -1;
            right: 0;
            width: 38.1vw;
            height: 25.1vw;
            img{
                width: 38.1vw;
                height: 25.1vw;
            }
        }
        .content{
            width: 100%;
            border-top: 1px solid #DDDDDD;
            .con-header{
                height: 12.3vw;
                margin: 3.2vw 0 2.3vw;
                width: 100%;
                text-align: left;
                p{  
                    width: 37.6vw;
                    height: 12.3vw;
                    margin-left: -2.8vw;
                    padding: 4.1vw 0 0 10vw;
                    font-size: 4.3vw;
                    font-family: "FZLT-blackBold";
                    color: #FFF;
                    line-height: 5.2vw;
                    background: url("../assets/newImages/common/navWap/page-title.png") no-repeat center center/cover;
                }
            }
            .con-main{
                margin: 1.2vw auto 0;
                width: 90.7vw;
                height: auto;
                .input-div{
                    width: 100%;
                    height: 8vw;
                    background: #FFF;
                    box-shadow: 0px 0px 4vw 0px rgba(231,231,231,0.5);
                    border-radius: 4vw;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 2.7vw 0 5.2vw;
                    input{
                        width: 75vw;
                        height: 8vw;
                        font-size: 3.2vw;
                        color: #333;
                        line-height: 3.6vw;
                        border: none;
                        background: none;
                        &::placeholder{
                            color: #AAA;
                        }
                    }
                    .search{
                        width: 8vw;
                        height: 8vw;
                        padding: 2.4vw;
                        cursor: pointer;
                        img{
                            vertical-align: top;
                            width: 3.1vw;
                            height: 3.1vw;
                        }
                    }
                }
                .guest-one{
                    width: 100%;
                    height: auto;
                    flex-wrap: wrap;
                    display: flex;
                    margin-top: 2.7vw;
                    .one{
                        width: 43.5vw;
                        height: 69.8vw;
                        border-radius: 0px 0px 0.3vw 0.3vw;
                        background: #fff;
                        box-shadow: 0px 0px 1.6vw 0px rgba(235,235,235,0.5);
                        margin: 0 3.5vw 2.7vw 0;
                        &:nth-child(2n){
                            margin-right: 0;
                        }
                        .top{
                            width:43.7vw;
                            height: 43.7vw;
                            // padding: 5.9vw 0 0 6.3vw;
                            background: url('../assets/newImages/guest/bg2.png')no-repeat center center/cover;
                            overflow: hidden;
                            position: relative;
                            img{
                                height: 38vw;
                                // width: 33.5vw;
                                position: absolute;
                                top: 6.5vw;
                                left: 50%;
                                transform: translateX(-50%);
                                // left: 6.3vw;
                            }
                            
                        }
                        .bottom{
                            // height: pxToVw(160);
                            padding: 2.8vw  3.5vw 0;
                            .name{
                                font-size: 3.5vw;
                                font-family: "FZLT-blackLittle";
                                font-weight: normal;
                                color: #333333;
                                width: 11vw;
                                line-height: 4vw;
                                text-align: justify;
                                text-align-last: justify;
                                word-break: break-all;
                                text-justify: distribute;
                            }
                            .introduce{
                                height: 13.2vw;
                                font-size: 3.2vw;
                                font-weight: normal;
                                color: #999999;
                                line-height: 4.4vw;
                                margin-top: 2.3vw;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
            }
        }
    }
    .wap-cover{
        position: fixed;
        left: 0;
        overflow: hidden !important;
    }
    .maskWap{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0,0,0,0.5);
        z-index: 1000;
        cursor: pointer;
    }
    .popWap{
        width: 88.3vw;
        // height: pxToVw(653);
        height: auto;
        position: fixed;
        z-index:10001;
        left:50% ;
        transform: translate(-50%,-50%);
        top: 50%;
        padding-top: 7.3vw;
        .top-div{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 7.3vw;
        }
        .p{
            width: 2.8vw;
            height: 2.9vw;
            position: absolute;
            right: 3.9vw;
            top: 11.4vw;
            img{
                width: 100%;
                vertical-align: top;
            }
        }
        .border{
            margin: auto 0;
            padding: 0 3.5vw 4.7vw;
            border-bottom: 1px solid #EEEEEE;
            background: #fff;
            .intro{
                // padding:0 3.5vw ;
                display: flex;
                height: 21.5vw;
                .pic{
                    width: 28.8vw;
                    height: 28.8vw;
                    position: relative;
                    overflow: hidden;
                    top: -7.3vw;
                    background: url('../assets/newImages/guest/pop-bg.png') no-repeat center center/cover;
                    img{
                        // width: 21.2vw;
                        height: 22.5vw;
                        position: absolute;
                        top: 5.2vw;
                        left: 50%;
                        transform: translateX(-50%);
                        // left: 3.8vw;
                    }
                }
                .explain{
                    width: 48.2vw;
                    margin-left:2vw;
                    display: flex;
                    flex-direction: column;
                    text-align: left;
                    .name{
                        font-size: 3.5vw;
                        font-weight: normal;
                        color: #333333;
                        font-family: "FZLT-blackLittle";
                        line-height: 4vw;
                        margin-top: 7.1vw;
                        width: 12vw;
                        text-align: justify;
                        text-align-last: justify;
                        word-break: break-all;
                        text-justify: distribute;
                    }
                    .post{
                        font-size: 3.2vw;
                        font-weight: normal;
                        color: #666;
                        line-height: 3.7vw;
                        margin-top: 1.5vw;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    
                }
            }
            .text{
                font-size: 3.2vw;
                font-weight: normal;
                color: #999;
                line-height: 4.8vw;
                margin: 1.9vw 0vw 0 1.6vw;
                // height: 23.8vw;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 5;
                -webkit-box-orient: vertical;
            }
        }
        .agenda{
            background: #fff;
            padding-bottom: 4.8vw;
            .title-div{
                padding-top: 2.7vw;
                width: 100%;
                .title{
                    width: 31.6vw;
                    height: 9.1vw;
                    background: url('../assets/newImages/guest/pop-title.png')no-repeat center center/cover;
                    padding: 3.2vw 0 0 8.9vw;
                    p{
                        font-size: 3.7vw;
                        font-weight: normal;
                        color: #FFFFFF;
                        line-height: 4.4vw;
                    }
                }
            }
            .agenda-item{
                position: relative;
                z-index: 5;
                width: 100%;
                height: auto;
                max-height: 30vh;
                overflow-y: scroll;
                cursor: pointer;
                scrollbar-width: none;
                -ms-overflow-style: none;
                &::-webkit-scrollbar{
                    width: 0px;
                }
                .item{
                    width: 100%;
                    padding: 4.1vw 0 0.5vw 4.4vw;
                    .top{
                        display: flex;
                        align-items: center;
                        .t-img{
                            width: 1.8vw;
                            height: 1.8vw;
                            img{
                                width: 100%;
                                vertical-align: top;
                            }
                        }
                        .t-text{
                            width: 72vw;
                            font-size: 3.5vw;
                            font-weight: normal;
                            color: #333333;
                            line-height: 4vw;
                            margin-left: 3.3vw;
                            overflow:hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        }
                    }
                    .place{
                        display: flex;
                        align-items: center;
                        margin: 2.1vw 0 0 5.1vw;
                        .p-time{
                            width: 29vw;
                            display: flex;
                            align-items: center;
                            margin-right: 3.7vw;
                            .time-img{
                                width: 3.1vw;
                                height: 3.2vw;
                                img{
                                    width: 100%;
                                    min-width: 3.1vw;
                                    vertical-align: top;
                                }
                            }
                            .address-img{
                                width: 2.9vw;
                                height: 3.9vw;
                                img{
                                    width: 100%;
                                    min-width: 2.9vw;
                                    vertical-align: top;
                                }
                            }
                            p{
                                width: 24vw;
                                font-size: 3.2vw;
                                font-weight: normal;
                                color: #999999;
                                line-height: 3.6vw;
                                margin-left: 1.5vw;

                            }
                        }
                        .p-address{
                            width: 39vw;
                            p{
                                width: 34vw;
                            }
                        }
                    }
                }
            }
        }
        .bottom-div{
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 6;
            width: 100%;
            height: 4.8vw;
        }
    }
} 
</style>